export default {"src":"/_next/static/media/check-circle-red.400fdeae.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};